import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
import auth from './modules/auth'
import fundraiser from './modules/fundraiser'
import cashouts from './modules/cashouts'
import treasurers from './modules/treasurers'
import images from './modules/images'
import docs from './modules/docs'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
})

export default createStore({
  plugins: [vuexLocal.plugin],
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
  },
  actions: {},
  modules: {
    auth,
    fundraiser,
    cashouts,
    treasurers,
    images,
    docs,
  },
})
